/**
 * Returns true if the given content ID is a virtual ID created by uuid rather than
 * a real content ID.
 */
export function isVirtualContentId(contentId: string): boolean {
  return contentId.includes('-');
}
